export default __webpack_public_path__ + "static/media/user.a168385f.svg";